module.exports = __webpack_public_path__ + "static/media/Little-Girl-Laughing-A1.d2d9d8e7.mp3";